import { Bot, Crown, Globe, PhoneCall, Send, TrendingUp } from 'lucide-react'
import React from 'react'

interface QuickStatCardProps {
  totalMessages: number;
  voiceCalls: number;
  aiInteractions: number;
  countries: number;
}


const QuickStatCard: React.FC<QuickStatCardProps> = ({
  totalMessages,
  voiceCalls,
  aiInteractions,
  countries,
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
      {/* Total Messages */}
      <div className="bg-white/60 backdrop-blur-sm rounded-2xl p-6 border border-slate-200 shadow-sm">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-slate-500 mb-1">Total Messages</p>
            <p className="text-2xl font-bold text-slate-800">
              {totalMessages.toLocaleString()}
            </p>
          </div>
          <div className="p-3 bg-blue-100 rounded-xl">
            <Send className="w-6 h-6 text-blue-600" />
          </div>
        </div>
      </div>

      {/* Voice Calls */}
      <div className="bg-white/60 backdrop-blur-sm rounded-2xl p-6 border border-slate-200 shadow-sm">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-slate-500 mb-1">Voice Calls</p>
            <p className="text-2xl font-bold text-slate-800">
              {voiceCalls.toLocaleString()}
            </p>
          </div>
          <div className="p-3 bg-red-100 rounded-xl">
            <PhoneCall className="w-6 h-6 text-red-600" />
          </div>
        </div>
      </div>

      {/* AI Interactions */}
      <div className="bg-white/60 backdrop-blur-sm rounded-2xl p-6 border border-slate-200 shadow-sm">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-slate-500 mb-1">AI Interactions</p>
            <p className="text-2xl font-bold text-slate-800">
              {aiInteractions.toLocaleString()}
            </p>
          </div>
          <div className="p-3 bg-indigo-100 rounded-xl">
            <Bot className="w-6 h-6 text-indigo-600" />
          </div>
        </div>
      </div>

      {/* Countries */}
      <div className="bg-white/60 backdrop-blur-sm rounded-2xl p-6 border border-slate-200 shadow-sm">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-slate-500 mb-1">Countries</p>
            <p className="text-2xl font-bold text-slate-800">
              {countries.toLocaleString()}
            </p>
          </div>
          <div className="p-3 bg-green-100 rounded-xl">
            <Globe className="w-6 h-6 text-green-600" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickStatCard